import { call, put, select } from 'redux-saga/effects';
import { makeRequest } from '../../../core/js/sagas/makeRequest';
import {
    getAvailableMeasurementUnits,
    updateSizeGuideConversion,
    updateSizeGuideMeasurementUnit,
    updateSizeGuideFit
} from '../actions/sizeGuideActions';
import { findSelectedConversion } from '../utils/sizeGuideUtils.js';
import { getSizeGuideDataRoute } from '../../../core/js/utils/apiRoutes';
import { error } from '../../../core/js/utils/logger';

export function* changeSizeGuideConversionSaga(state, conversionSlug) {
    const contentType = 'sizeGuideConversion';
    const selectedConversion = yield call(getSizeGuideDataSaga, state, contentType, conversionSlug);

    if (selectedConversion) {
        yield put(updateSizeGuideConversion(selectedConversion));
        yield call(updateSizeGuideMeasurementUnitSaga, selectedConversion);
    }
}

export function* selectSizeGuideConversionSaga(previousConversion, selectedFit) {
    const state = yield select();
    const availableConversions = _.get(selectedFit, 'availableConversions');

    if (!_.get(previousConversion, 'isDefault')) {
        const previousConversionSlug = _.get(previousConversion, 'slug', null);
        const selectedConversionSlug = findSelectedConversion(previousConversionSlug, availableConversions);

        if (selectedConversionSlug) {
            return yield call(changeSizeGuideConversionSaga, state, selectedConversionSlug);
        }
    }
    return yield put(updateSizeGuideConversion(selectedFit.defaultConversion));
}

export function* getSizeGuideForTypeCodeSaga() {
    const state = yield select();
    const productSizeTypeCode = _.get(state, 'product.productControls.sizeTypeCode', null);
    const availableFitGuides = _.get(state, 'product.sizeGuide.fits', null);

    try {
        if (productSizeTypeCode && (availableFitGuides && availableFitGuides.length > 1)) {
            const selectedProductFit = productSizeTypeCode.toLowerCase();

            for (const fit of availableFitGuides) {
                const hasGuideForSelectedProductFit = _.split(fit.slug, '_').includes(selectedProductFit);

                if (hasGuideForSelectedProductFit) {
                    let changeSizeGuideFit = {};
                    const previousSizeGuideFitSlug = _.get(state, 'product.sizeGuide.selectedFit.slug', null);

                    if (fit.slug !== previousSizeGuideFitSlug) {
                        changeSizeGuideFit = yield call(changeSizeGuideFitSaga, state, fit.slug);
                    }
                    return changeSizeGuideFit;
                }
            }
        }
        return yield call(getAvailableMeasurementUnitsSaga);
    } catch(err) {
        error('Error getting Size Guide For Type Code', err);
        return {};
    }
}

export function* updateSizeGuideMeasurementUnitSaga(selectedConversion) {
    const state = yield select();

    const previousUnit = _.get(state, 'product.sizeGuide.selectedUnit');
    const defaultUnit = _.get(selectedConversion, 'defaultUnitOfMeasurement', previousUnit);
    const selectedFit = _.get(state, 'product.sizeGuide.selectedFit');
    const defaultUnitInFit = _.get(selectedFit, `has${defaultUnit}`);

    if (defaultUnitInFit && (defaultUnit !== previousUnit)) {
        yield put(updateSizeGuideMeasurementUnit(defaultUnit));
    }
}

export function* changeSizeGuideFitSaga(state, fitSlug) {
    const contentType = 'sizeGuideContainer';
    const selectedFit = yield call(getSizeGuideDataSaga, state, contentType, fitSlug);
    const previousConversion = _.get(state, 'product.sizeGuide.selectedConversion', null);

    if (selectedFit) {
        yield put(updateSizeGuideFit(selectedFit));
        yield call(getAvailableMeasurementUnitsSaga, selectedFit);
        yield call(selectSizeGuideConversionSaga, previousConversion, selectedFit);
    }
}

export function* getAvailableMeasurementUnitsSaga(fit = null) {
    const state = yield select();

    const selectedFit = fit || _.get(state, 'product.sizeGuide.selectedFit');

    if (selectedFit) {
        const hasInches = _.isString(selectedFit.sizeGuideInches);
        const hasCentimeters = _.isString(selectedFit.sizeGuideCentimeters);
        yield put(getAvailableMeasurementUnits(hasInches, hasCentimeters));
    }
}

export function* getSizeGuideDataSaga(state, contentType, slug) {

    try {
        const params = {
            contentType: contentType,
            slug: slug
        };
        const route = getSizeGuideDataRoute(state, params);
        const res = yield call(makeRequest, route);

        return res;
    } catch (err) {
        error('Unable to get Size Guide Conversion');
        return null;
    }
}
